import {
    REQUEST_ERROR    
  } from "../actions";
  
  export const notifyError = (error) => ({
    type: REQUEST_ERROR,
    payload: {error}
  });